module.exports = {
      id: "app-recommend-bg-usage",
      viewBox: "0 0 630 816",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#app-recommend-bg-usage",
      toString: function () {
        return this.url;
      }
    }